// Generated by ReScript, PLEASE EDIT WITH CARE


var vehicle_details_best_for = "Best for sending:";

var service_category_trucks = "trucks";

var service_category_two_wheelers = "two wheeler";

var service_category_2w = "two wheelers";

var packers_and_movers = "packers and movers";

var heightToShowGetEstimateStickyFrom = 700;

export {
  vehicle_details_best_for ,
  service_category_trucks ,
  service_category_two_wheelers ,
  service_category_2w ,
  packers_and_movers ,
  heightToShowGetEstimateStickyFrom ,
}
/* No side effect */
